import { render, staticRenderFns } from "./ResourceCalendarImportExportTab.vue?vue&type=template&id=3639ead1&scoped=true"
import script from "./ResourceCalendarImportExportTab.vue?vue&type=script&lang=js"
export * from "./ResourceCalendarImportExportTab.vue?vue&type=script&lang=js"
import style0 from "./ResourceCalendarImportExportTab.vue?vue&type=style&index=0&id=3639ead1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3639ead1",
  null
  
)

export default component.exports